import { Routes } from '@angular/router';
import { UserGetComponent } from 'src/app/entities/user/user-get/user-get.component';
import { ChatComponent } from 'src/app/components/chat/chat.component';
/*guard admin*/
import { AdminGuardService } from 'src/app/services/guards/admin-guard.service';



const ROUTES_HOME:Routes=[
  {path:'user/get', component:UserGetComponent},
  {path:'chat', component:ChatComponent},
  {path:'user/admin',loadChildren:()=>import('../../entities/user/user-admin/user-admin.module').then((m)=>m.UserAdminModule),canActivate:[AdminGuardService]},
  {path:'user/edit',loadChildren:()=>import('../../entities/user/user-put/user-put.module').then((m)=>m.UserPutModule)},
  {path:'user/profile',loadChildren:()=>import('../../entities/user/user-profile/user-profile.module').then((m)=>m.UserProfileModule)},
  {path:'user/edit/password',loadChildren:()=>import('../../entities/user/user-password/user-password.module').then((m)=>m.UserPasswordModule)},
  {path:'publication/create',loadChildren:()=>import('../../entities/publication/publication-post/publication-post.module').then((m)=>m.PublicationPostModule)},
  {path:'publication/list',loadChildren:()=>import('../../entities/publication/publication-get/publication-get.module').then((m)=>m.PublicationGetModule)},
  {path:'publication/profile',loadChildren:()=>import('../../entities/publication/publication-profile/publication-profile.module').then((m)=>m.PublicationProfileModule)},
  {path:'publication/user',loadChildren:()=>import('../../entities/publication/publication-user/publication-user.module').then((m)=>m.PublicationUserModule)},
  {path:'publication/edit',loadChildren:()=>import('../../entities/publication/publication-put/publication-put.module').then((m)=>m.PublicationPutModule)},
  {path:'map/create',loadChildren:()=>import('../../entities/map/map-post/map-post.module').then((m)=>m.MapPostModule)},
  {path:'map/list',loadChildren:()=>import('../../entities/map/map-get/map-get.module').then((m)=>m.MapGetModule)},
  {path:'**',pathMatch:'full',redirectTo:'user/profile'}
]
export{
  ROUTES_HOME
}

